import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faChartLine, faDesktop, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
// 1. IMPORTAR A FRAMER MOTION
import { motion } from 'framer-motion';

// CSS para os "pontos" do carrossel (ATUALIZADO COM NOVA COR)
const carouselStyles = `
  /* Garante que o container do slick tenha overflow visível para as sombras */
  .slick-list {
    overflow: visible;
    padding-top: 10px; /* Espaço para a sombra não cortar */
    margin-top: -10px;
  }
  .slick-slide > div { /* Target the div immediately inside slick-slide */
    margin: 0 10px; /* Adjust horizontal spacing between slides */
  }
  .slick-list {
    margin: 0 -10px; /* Counteract the slide margin */
  }

  .slick-dots {
    bottom: -40px; /* Mais espaço abaixo */
  }
  .slick-dots li button:before {
    font-size: 12px;
    color: #cbd5e1; /* slate-300 (Cinza sutil) */
    opacity: 0.75;
    transition: all 0.3s ease;
  }
  .slick-dots li.slick-active button:before {
    color: #242A53; /* SUA NOVA COR PRIMÁRIA */
    transform: scale(1.5);
    opacity: 1;
  }
`;

// 2. DEFINIR AS VARIANTES DE ANIMAÇÃO
// Para containers com filhos que aparecem um após o outro
const staggerContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Tempo entre cada card
    },
  },
};

// Fade in subindo (para cada card)
const fadeInUp = {
  hidden: { y: 30, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 12 } },
};

const TrabalhosCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const trabalhos = [
    { id: 1, icon: faBox, subtitulo: "Controle de Estoque", description: 'Sistema eficiente e preciso para gestão de inventário.' },
    { id: 2, icon: faChartLine, subtitulo: "Controle Financeiro", description: 'Ferramenta completa para gestão financeira empresarial.' },
    { id: 4, icon: faMobileAlt, subtitulo: "Pedido na Mesa (QR Code)", description: 'Solução ágil para pedidos diretamente da mesa via celular.' },
    { id: 3, icon: faDesktop, subtitulo: "Site Institucional Completo", description: 'Desenvolvimento de site moderno destacando a identidade visual.' },
    { id: 5, icon: faChartLine, subtitulo: "Dashboard Financeiro", description: 'Visualização clara e inteligente dos dados financeiros.' },
    { id: 6, icon: faBox, subtitulo: "Gestão de Recicláveis", description: 'Sistema especializado para gerenciamento de materiais recicláveis.' }
  ];

  return (
    <>
      <style>{carouselStyles}</style>

      {/* Seção principal com fundo branco */}
      <div className="trabalhos-carousel bg-white py-10 md:py-16 px-4 md:px-8 overflow-hidden">

        {/* O Título e Subtítulo foram removidos daqui. 
          Eles devem ficar na seção principal do App.js, 
          acima de onde você chama este componente <Trabalhos />.
        */}

        {/* 3. APLICAR O CONTAINER DE ANIMAÇÃO NO SLIDER */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show" // Anima quando o carrossel entra na tela
          viewport={{ once: true, amount: 0.2 }} // Dispara com 20% visível, só 1 vez
        >
          <Slider {...settings}>
            {trabalhos.map((trabalho) => (
              // 4. APLICAR A VARIANTE DE FILHO A CADA SLIDE
              <motion.div
                key={trabalho.id}
                variants={fadeInUp} // Animação de subida para cada card
                className="py-6" // Padding vertical p/ sombra
              >
                {/* 5. CARD ATUALIZADO COM NOVAS CORES E ANIMAÇÃO DE HOVER */}
                <motion.div
                  className="group bg-white rounded-2xl p-8 h-full min-h-[240px] text-left shadow-lg hover:shadow-2xl hover:shadow-[#242A53]/10 border border-gray-100 hover:border-gray-200 transition-all duration-300 flex flex-col"
                  whileHover={{ y: -8 }} // Animação "spring"
                  transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                >

                  {/* Ícone com nova paleta de cores */}
                  <div className="bg-[#c0cccc]/40 text-[#242A53] w-14 h-14 rounded-full flex items-center justify-center mb-5 shadow-sm transition-colors duration-300 group-hover:bg-[#242A53] group-hover:text-white">
                    <FontAwesomeIcon icon={trabalho.icon} className="text-2xl" />
                  </div>

                  {/* Subtítulo com nova cor */}
                  <h4 className="text-xl font-bold text-[#242A53] mb-2 flex-grow">
                    {trabalho.subtitulo}
                  </h4>

                  {/* Descrição */}
                  <p className="text-gray-600 text-base leading-relaxed mt-auto">
                    {trabalho.description}
                  </p>
                </motion.div>
              </motion.div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </>
  );
};

export default TrabalhosCarousel;